import { render, staticRenderFns } from "./ByOs.vue?vue&type=template&id=1947273e&scoped=true"
import script from "./ByOs.vue?vue&type=script&lang=js"
export * from "./ByOs.vue?vue&type=script&lang=js"
import style0 from "./ByOs.vue?vue&type=style&index=0&id=1947273e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947273e",
  null
  
)

export default component.exports